import { render } from "./DigitalContentTermsModal.vue?vue&type=template&id=53b0ec70"
import script from "./DigitalContentTermsModal.vue?vue&type=script&lang=js"
export * from "./DigitalContentTermsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__